module.exports = __webpack_public_path__ + "static/media/icon_swipe.6804535f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/infopanel/icon_swipe.svg
// module id = 438
// module chunks = 0